module.exports = __webpack_public_path__ + "static/img/wow.c3664708.png";